import snakeCase from 'lodash/snakeCase';
import prependPrefix from '@/utils/prependPrefix';
import CommonParams from '../constants/CommonParams';

const { PAGE, PAGE_FROM, PAGE_SIZE } = CommonParams;

const parsePaginationParams = (
  defaultPageSize: number,
  urlSearch: URLSearchParams,
  prefix?: string,
) => {
  const page = +(urlSearch?.get(prependPrefix(PAGE, prefix)) || 1);
  const pageSize = +(
    urlSearch?.get(snakeCase(prependPrefix(PAGE_SIZE, prefix))) ||
    defaultPageSize
  );
  const pageFrom = page ? (page - 1) * pageSize : 0;

  return {
    [PAGE]: page,
    [PAGE_FROM]: pageFrom,
    [PAGE_SIZE]: pageSize,
  };
};

export default parsePaginationParams;
